export class SC_ApiTimezone {
    static readonly NULL = 0;
    static readonly PACIFIC_HONOLULU = 1;
    static readonly AMERICA_LOS_ANGELES = 2;
    static readonly AMERICA_PHOENIX = 3;
    static readonly AMERICA_DENVER = 4;
    static readonly AMERICA_CHICAGO = 5;
    static readonly AMERICA_NEW_YORK = 6;
    static readonly AMERICA_PUERTO_RICO = 7;
    static readonly UTC = 8;
    static readonly LOCAL = 9;
    static readonly DEHYDRATED = 10;

    constructor(private timezone: number = SC_ApiTimezone.NULL) { }

    static fromAPI(apiValue: number): SC_ApiTimezone {
        switch (apiValue) {
            case SC_ApiTimezone.PACIFIC_HONOLULU:
                return new SC_ApiTimezone(SC_ApiTimezone.PACIFIC_HONOLULU);
            case SC_ApiTimezone.AMERICA_LOS_ANGELES:
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_LOS_ANGELES);
            case SC_ApiTimezone.AMERICA_PHOENIX:
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_PHOENIX);
            case SC_ApiTimezone.AMERICA_DENVER:
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_DENVER);
            case SC_ApiTimezone.AMERICA_CHICAGO:
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_CHICAGO);
            case SC_ApiTimezone.AMERICA_NEW_YORK:
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_NEW_YORK);
            case SC_ApiTimezone.AMERICA_PUERTO_RICO:
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_PUERTO_RICO);
            case SC_ApiTimezone.UTC:
                return new SC_ApiTimezone(SC_ApiTimezone.UTC);
            case SC_ApiTimezone.DEHYDRATED:
                return new SC_ApiTimezone(SC_ApiTimezone.DEHYDRATED);
            case SC_ApiTimezone.LOCAL:
                return new SC_ApiTimezone(SC_ApiTimezone.LOCAL);
            default:
                return new SC_ApiTimezone();
        }
    }

    is(type: number): boolean {
        return this.timezone === type;
    }

    toAPI(): number {
        return this.timezone;
    }

    clone(): SC_ApiTimezone {
        return new SC_ApiTimezone(this.timezone);
    }

    /**
     * Merges another SC_ApiTimezone object into this one, replacing null fields
     */
    merge(other: SC_ApiTimezone): SC_ApiTimezone {
        if (other.timezone !== SC_ApiTimezone.NULL) {
            this.timezone = other.timezone;
        }
        return this;
    }

    static readonly types = [
        { key: SC_ApiTimezone.PACIFIC_HONOLULU, display: "Pacific/Honolulu" },
        { key: SC_ApiTimezone.AMERICA_LOS_ANGELES, display: "America/Los_Angeles" },
        { key: SC_ApiTimezone.AMERICA_PHOENIX, display: "America/Phoenix" },
        { key: SC_ApiTimezone.AMERICA_DENVER, display: "America/Denver" },
        { key: SC_ApiTimezone.AMERICA_CHICAGO, display: "America/Chicago" },
        { key: SC_ApiTimezone.AMERICA_NEW_YORK, display: "America/New_York" },
        { key: SC_ApiTimezone.AMERICA_PUERTO_RICO, display: "America/Puerto_Rico" },
    ];

    static fromString(timezoneString: string): SC_ApiTimezone {
        switch (timezoneString) {
            case "Pacific/Honolulu":
                return new SC_ApiTimezone(SC_ApiTimezone.PACIFIC_HONOLULU);
            case "America/Los_Angeles":
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_LOS_ANGELES);
            case "America/Phoenix":
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_PHOENIX);
            case "America/Denver":
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_DENVER);
            case "America/Chicago":
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_CHICAGO);
            case "America/New_York":
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_NEW_YORK);
            case "America/Puerto_Rico":
                return new SC_ApiTimezone(SC_ApiTimezone.AMERICA_PUERTO_RICO);
            case "UTC":
                return new SC_ApiTimezone(SC_ApiTimezone.UTC);
            default:
                return new SC_ApiTimezone();
        }
    }

    toString(): string {
        switch (this.timezone) {
            case SC_ApiTimezone.PACIFIC_HONOLULU:
                return "Pacific/Honolulu";
            case SC_ApiTimezone.AMERICA_LOS_ANGELES:
                return "America/Los_Angeles";
            case SC_ApiTimezone.AMERICA_PHOENIX:
                return "America/Phoenix";
            case SC_ApiTimezone.AMERICA_DENVER:
                return "America/Denver";
            case SC_ApiTimezone.AMERICA_CHICAGO:
                return "America/Chicago";
            case SC_ApiTimezone.AMERICA_NEW_YORK:
                return "America/New_York";
            case SC_ApiTimezone.AMERICA_PUERTO_RICO:
                return "America/Puerto_Rico";
            case SC_ApiTimezone.UTC:
                return "UTC";
            case SC_ApiTimezone.DEHYDRATED:
                return "UTC";
            case SC_ApiTimezone.LOCAL:
                return "UTC";
            default:
                return "Not Set";
        }
    }
}
